import _ from 'lodash'

/**
 * get all visible form for the auth user (based on his role & department)
 *
 * @param {object} gateway       - all gateways forms from firebase
 * @param {object} currentUser   - auth user
 * @param {object} forms         - all forms from firebase
 * @returns {array}              - forms list
 */
export default function getUserForms(gateway, currentUser, forms) {

   let gatewayList = _.values(gateway)

   let { department, role } = currentUser

   gatewayList = _.filter(gatewayList, (gate) => forms[gate.formId] && // don't show the deleted forms
      (
         (gate.departments?.includes(department) && gate.roles?.includes(role)) // the form departments and roles are identified
         ||
         (_.isEmpty(gate.roles) && gate.departments?.includes(department)) // the form departments only are identified
         ||
         (_.isEmpty(gate.departments) && gate.roles?.includes(role)) // the form roles only are identified
         ||
         (_.isEmpty(gate.roles) && _.isEmpty(gate.departments)) // the form departments and roles aren't identified
      )
   )

   return gatewayList
}
